import { AssessmentStatus } from 'Services/BeGateway/__generated__/beGatewayTypes';
import { talkEventsQuery_unmindEvents_edges_node as event } from 'Services/BeGateway/Talk/__generated__/talkEventsQuery';
import { getMeetURL } from '../getMeetURL';

export default (appointment: event, userID?: string, index?: number) => {
  if (!appointment || !userID || (index !== undefined && index > 0))
    return false;

  const currentUserEventGuest = appointment?.eventGuests?.find(
    guest => guest?.contact?.unmindUserId === userID,
  );

  if (!currentUserEventGuest) return false;

  const isRequired =
    currentUserEventGuest?.assessmentStatus &&
    currentUserEventGuest.assessmentStatus !== AssessmentStatus.not_needed;
  const isCompleted =
    currentUserEventGuest?.assessmentStatus === AssessmentStatus.complete;

  return {
    isRequired: isRequired || false, // prevent `null` values for simplicity
    isCompleted,
    url: getMeetURL(appointment, true),
  };
};
